<div class="splash-screen" *ngIf="isVisible">

  <!-- Falling Items -->
  <div class="falling-layer">

    <div
      *ngFor="let item of fallingItems"
      class="falling-item"
      [ngClass]="item.type"
      [style.left.%]="item.left"
      [style.animation-duration.s]="item.duration"
      [style.animation-delay.s]="item.delay"
      [style.width.px]="item.size"
      [style.height.px]="item.size">

    </div>

  </div>

  <!-- CENTER CONTENT -->
  <div class="content">

    <!-- Logo -->
    <div class="logo">
      <img src="https://cmax-banners.pages.dev/assets/hr-logo.png">
    </div>

    <!-- Loader -->
    <div class="casino-loader">

      <!-- Coin -->
      <!-- <div class="coin-loader"></div> -->

      <!-- Dice (FIXED) -->
      <div class="dice-loader">

        <div
          class="dot"
      *ngFor="let dot of getDots(currentDiceIndex)"
          [style.top]="dot.top"
          [style.left]="dot.left">
        </div>

      </div>

      <!-- Diamond -->
      <!-- <div class="diamond-loader"></div> -->

    </div>

    <p class="progress-text">
      {{progress}}% Loaded
    </p>

  </div>

</div>